import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { Box, Drawer, Hidden, List } from '@mui/material';
import { GlobalContext } from '/context';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles, withStyles } from '@mui/styles';

import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const useStyles = makeStyles((theme) => ({
    mobileDrawer: {
        width: 256,
    },
    desktopDrawer: {
        width: 256,
        top: 64,
        height: 'calc(100% - 64px)',
    },
    avatar: {
        cursor: 'pointer',
        width: 64,
        height: 64,
    },
    treeItem: {
        paddingTop: 12,
        // paddingBottom: 5,
        fontWeight: 'bold',
    },
    treeLabel: {
        color: theme.palette.text.secondary,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: 14,
    },
}));

const NavBar = ({ onClose, onMobileClose, openMobile }) => {
    const classes = useStyles();
    const router = useRouter();
    const { state } = useContext(GlobalContext);

    const handleTreeClick = (tree) => {
        if (tree.children) return;
        router.push('/post/' + tree.id);
        onClose();
    };

    const content = (
        <Box height="100%" display="flex" flexDirection="column">
            <Box p={2}>
                <List>
                    <Box style={{ marginBottom: 20, marginTop: 10 }} onClick={onMobileClose}>
                        <CloseIcon color="#2F4858" fontSize="medium" />
                    </Box>
                    <SimpleTreeView
                        className={classes.tree}
                        defaultCollapseIcon={<ExpandMoreIcon />}
                        defaultExpandIcon={<ChevronRightIcon />}
                        multiSelect={false}
                    >
                        {state.menu.list.map((menu) => {
                            return (
                                <TreeItem
                                    onClick={() => handleTreeClick(menu)}
                                    itemId={menu.id}
                                    label={menu.name}
                                    key={Math.random()}
                                    className={classes.treeItem}
                                    classes={{ label: classes.treeLabel }}
                                >
                                    {menu.children &&
                                        menu.children.map((child) => {
                                            return (
                                                <TreeItem
                                                    onClick={() => handleTreeClick(child)}
                                                    key={child.id}
                                                    itemId={child.id}
                                                    label={child.name}
                                                    className={classes.treeItem}
                                                    classes={{ label: classes.treeLabel }}
                                                />
                                            );
                                        })}
                                </TreeItem>
                            );
                        })}
                    </SimpleTreeView>
                </List>
            </Box>
            <Box flexGrow={1} />
        </Box>
    );

    return (
        <div>
            <Hidden lgUp>
                <Drawer
                    anchor="right"
                    classes={{ paper: classes.mobileDrawer }}
                    onClose={onMobileClose}
                    open={openMobile}
                    variant="temporary"
                >
                    {content}
                </Drawer>
            </Hidden>
            <Hidden mdDown>
                <Drawer
                    anchor="left"
                    classes={{ paper: classes.desktopDrawer }}
                    open
                    variant="persistent"
                >
                    {content}
                </Drawer>
            </Hidden>
        </div>
    );
};

NavBar.propTypes = {
    onMobileClose: PropTypes.func,
    openMobile: PropTypes.bool,
};

// NavBar.defaultProps = {
//     onMobileClose: () => {},
//     openMobile: false,
// };

export default NavBar;
